
























import { Component, Mixins } from 'vue-property-decorator';
import { FormSubmissionResult, Context } from 'client-website-ts-library/types';
import { Map } from 'client-website-ts-library/components';
import { View } from 'client-website-ts-library/plugins';
import Form from '@/components/Forms/Form.vue';
import { Client, Config } from 'client-website-ts-library/services';

@Component({
  components: {
    Map,
    Form,
  },
})
export default class OffMarketPINAccess extends Mixins(View) {
  private isReauth = false;

  public context: Context = {
    Items: [],
    ClientWebsiteId: Config.Website.Id,
  };

  mounted() {
    this.isReauth = this.$route.query?.reauth === 'true';

    const next = this.$route.query?.next as string | undefined;

    if (next) {
      const decoded = decodeURIComponent(next);
      const parts = decoded.split('/');
      const id = parts[parts.length - 1];

      if (id) {
        this.context.Items.push({
          Type: 1,
          Id: id,
        });
      }
    }
  }

  handleSubmitted(result?: FormSubmissionResult) {
    if (result && result.GrantedToken) {
      Client.SetAuthToken(result.GrantedToken);

      let next = '/';

      if (this.$route.query?.next) {
        next = this.$route.query?.next as string;
      }

      this.$router.push(next);
    }
  }
}
